import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { UserDto, UserRequestDto } from '../integrations/seedling-supply-service/dto/models';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  userDataByUser = (user: UserRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, UserDto>({
      method: 'POST',
      url: '/api/app/user/user-data',
      body: user,
    },
    { apiName: this.apiName,...config });
}